import { gaEvent } from "@/lib/track";
import { useEffect, useState } from "react";
import { platformClient } from "@/lib/musicApi";

// Hybrid search API (services/search.py). scope: music | global | community.
export const doSearch = ({ q, scope = "global", limit = 20 }) =>
  platformClient.get("/search", { params: { q, scope, limit } }).then((r) => r.data);

export const getMusicTags = () =>
  platformClient.get("/music/tags").then((r) => r.data).catch(() => ({ genres: [], moods: [], energy: [], themes: [], languages: [], bpm: [] }));

// Last 5 searches, per spec, in localStorage.
const RECENT_KEY = "samtwo_recent_searches";

export const getRecentSearches = () => {
  try {
    const raw = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
    return Array.isArray(raw) ? raw.slice(0, 5) : [];
  } catch {
    return [];
  }
};

export const addRecentSearch = (q) => {
  const term = (q || "").trim();
  if (!term) return getRecentSearches();
  gaEvent("search", { search_term: term.slice(0, 100) });
  const next = [term, ...getRecentSearches().filter((t) => t.toLowerCase() !== term.toLowerCase())].slice(0, 5);
  try {
    localStorage.setItem(RECENT_KEY, JSON.stringify(next));
  } catch {}
  return next;
};

export const clearRecentSearches = () => {
  try {
    localStorage.removeItem(RECENT_KEY);
  } catch {}
  return [];
};

// Debounce any value (spec: 300ms as the user types).
export const useDebouncedValue = (value, delay = 300) => {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(id);
  }, [value, delay]);
  return debounced;
};
